(function benefitBundleGift() {
  const SECTION_SELECTORS = [
    '#ProductSection--product-template-new-opendots-two',
    '#ProductSection--product-template-new-opendots-air',
    '#ProductSection--product-template-new-openrunpro2',
    '#ProductSection--product-template-new-openrun',
    '#ProductSection--product-template-new-openfit2-plus',
  ];

  const CASE_BENEFIT_HANDLES = new Set([
    'shokz-clip-on-earbud-carrying-case-copy',
    'shokz-clip-on-earbud-carrying-case',
  ]);

  const EARRING_BENEFIT_HANDLES = new Set([
    'shokz-earbuds-accessory-lilac',
    'shokz-earbuds-accessory-pianokeys',
    'shokz-earbuds-accessory-nacre',
  ]);
  const AP_EXCLUSIVE_GIFT_BY_PRODUCT = {
    'opendots-2-ap': 'shokz-canvas-bag',
    'opendots-air-ap': 'shokz-dry-towel',
  };

  function getBenefitGa4ButtonName(benefitHandle) {
    const handle = String(benefitHandle || '').trim().toLowerCase();
    if (CASE_BENEFIT_HANDLES.has(handle)) return 'case';
    if (EARRING_BENEFIT_HANDLES.has(handle)) return 'earring';
    return '';
  }

  function getBenefitContentName(benefitWrapper) {
    const titleEl = benefitWrapper?.querySelector('.benefit-title span');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  function pushBenefitSelectContentGa4(benefitWrapper) {
    if (!benefitWrapper || typeof window.dataLayer === 'undefined') return;

    const buttonName = getBenefitGa4ButtonName(benefitWrapper.dataset.benefit || '');
    if (!buttonName) return;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'gift',
        content_name: getBenefitContentName(benefitWrapper),
        button_name: buttonName,
      },
    });
  }

  function normalizeColorName(value) {
    return (value || '').trim().toLowerCase();
  }

  function parseVariantMatch(raw) {
    return (raw || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function benefitMatchesColor(variantMatchRaw, selectedColor) {
    const raw = (variantMatchRaw || '').trim();
    if (!raw) return true;
    if (!selectedColor) return false;

    const normalizedSelected = normalizeColorName(selectedColor);
    return parseVariantMatch(raw).some((color) => normalizeColorName(color) === normalizedSelected);
  }

  function getBenefitVariantMatch(benefitWrapper) {
    return benefitWrapper.dataset.variantMatch || benefitWrapper.getAttribute('data') || '';
  }

  function getProductHandleFromPath() {
    const path = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    const match = path.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getApExclusiveGiftHandle() {
    return AP_EXCLUSIVE_GIFT_BY_PRODUCT[getProductHandleFromPath()] || '';
  }

  function getBundleItemType(benefitHandle) {
    const handle = String(benefitHandle || '').trim().toLowerCase();
  // 免费延保赠品使用独立 handle，统一标记为 extended_warranty。
    if (handle === 'shokz-care-extra-1-year-gift') return 'extended_warranty';
    if (handle === 'shokz-canvas-bag' || handle === 'shokz-dry-towel') return 'ap_exclusive_gift';
    if (handle === 'tcs-sydney-marathon-cowbell') return 'marathon_gift';
    return 'regular_gift';
  }

  function getSelectedProductColor(section) {
    const colorWrapper = section.querySelector(
      '.radio-wrapper[data-option-name="Color"] .options-color-wrapper.active, .radio-wrapper[data-option-name="Colour"] .options-color-wrapper.active'
    );

    if (colorWrapper) {
      const colorItem = colorWrapper.querySelector('[data-value]');
      if (colorItem?.dataset.value) return colorItem.dataset.value.trim();

      const title = colorWrapper.getAttribute('data-title');
      if (title) return title.trim();
    }

    const currentColorEl = section.querySelector('.current-option-color');
    if (currentColorEl?.textContent) return currentColorEl.textContent.trim();

    return '';
  }

  function getVisibleBenefitWrappers(section) {
    return Array.from(
      section.querySelectorAll(
        '.purchase-block .benefit-wrapper:not(.is-variant-hidden) .product-wrapper[data-benefit-variant-id]'
      )
    );
  }

  function isBenefitLocked(wrapper) {
    return wrapper.dataset.benefitLocked === 'true';
  }

  function setBenefitSelected(wrapper, selected) {
    const isAvailable = wrapper.dataset.benefitAvailable === 'true';
    const locked = isBenefitLocked(wrapper);
    const nextSelected = locked ? isAvailable : Boolean(selected && isAvailable);
    wrapper.classList.toggle('is-selected', nextSelected);
    wrapper.classList.toggle('active', nextSelected);
    const toggleButton = wrapper.querySelector('.benefit-checkbox-toggle');
    if (toggleButton) {
      toggleButton.setAttribute('aria-pressed', nextSelected ? 'true' : 'false');
    }
  }

  function getExclusiveGroup(wrapper) {
    return (wrapper.dataset.benefitExclusiveGroup || '').trim();
  }

  function isPickOneGiftWrapper(wrapper) {
    if (!wrapper || isBenefitLocked(wrapper)) return false;
    if (wrapper.dataset.benefitAvailable !== 'true') return false;
    return Boolean(getExclusiveGroup(wrapper));
  }

  function getPickOneGiftWrappers(section) {
    return getVisibleBenefitWrappers(section).filter(isPickOneGiftWrapper);
  }

  function hasPickOneGiftSelected(section) {
    const pickOneWrappers = getPickOneGiftWrappers(section);
    if (!pickOneWrappers.length) return true;
    return pickOneWrappers.some((wrapper) => wrapper.classList.contains('is-selected'));
  }

  function ensurePickOneGiftSelected(section) {
    const pickOneWrappers = getPickOneGiftWrappers(section);
    if (!pickOneWrappers.length || hasPickOneGiftSelected(section)) return;

    const preferred =
      pickOneWrappers.find((wrapper) => wrapper.dataset.benefitSelectedDefault === 'true') ||
      pickOneWrappers[0];

    applyBenefitSelectionRules(pickOneWrappers, preferred, true);
    setBenefitSelected(preferred, true);
  }

  function resolveExclusiveGroupDefaults(wrappers) {
    const seenGroups = new Set();

    wrappers.forEach((wrapper) => {
      if (!wrapper.classList.contains('is-selected')) return;

      const group = getExclusiveGroup(wrapper);
      if (!group) return;

      if (seenGroups.has(group)) {
        setBenefitSelected(wrapper, false);
        return;
      }

      seenGroups.add(group);
    });
  }

  function applyBenefitSelectionRules(wrappers, wrapper, shouldSelect) {
    if (!shouldSelect) return;

    const isCombinable = wrapper.dataset.benefitCanCombine !== 'false';
    const exclusiveGroup = getExclusiveGroup(wrapper);

    if (!isCombinable) {
      wrappers.forEach((item) => {
        if (item !== wrapper && !isBenefitLocked(item)) setBenefitSelected(item, false);
      });
      return;
    }

    wrappers.forEach((item) => {
      if (item === wrapper || isBenefitLocked(item)) return;

      if (item.dataset.benefitCanCombine === 'false') {
        setBenefitSelected(item, false);
        return;
      }

      if (exclusiveGroup && getExclusiveGroup(item) === exclusiveGroup) {
        setBenefitSelected(item, false);
      }
    });
  }

  function updateBenefitsByColor(section) {
    const selectedColor = getSelectedProductColor(section);
    const benefitWrappers = section.querySelectorAll('.purchase-block .benefit-wrapper');

    benefitWrappers.forEach((benefitWrapper) => {
      const variantMatch = getBenefitVariantMatch(benefitWrapper);
      const isVisible = benefitMatchesColor(variantMatch, selectedColor);
      const wasHidden = benefitWrapper.classList.contains('is-variant-hidden');
      const productWrapper = benefitWrapper.querySelector('.product-wrapper[data-benefit-variant-id]');

      benefitWrapper.classList.toggle('is-variant-hidden', !isVisible);

      if (!isVisible) {
        if (productWrapper && !isBenefitLocked(productWrapper)) setBenefitSelected(productWrapper, false);
        return;
      }

      if (wasHidden && productWrapper?.dataset.benefitSelectedDefault === 'true') {
        setBenefitSelected(productWrapper, true);
      }
    });

    resolveExclusiveGroupDefaults(getVisibleBenefitWrappers(section));
    ensurePickOneGiftSelected(section);
  }

  function bindBenefitColorSync(section) {
    if (section.dataset.benefitColorBound === 'true') return;
    section.dataset.benefitColorBound = 'true';

    section.addEventListener('click', (event) => {
      if (!event.target.closest('.options-color-wrapper')) return;
      window.requestAnimationFrame(() => updateBenefitsByColor(section));
    });

    section.querySelectorAll('.product-form__item').forEach((node) => {
      if (node.dataset.benefitColorObserver === 'true') return;
      node.dataset.benefitColorObserver = 'true';

      const observer = new MutationObserver(() => updateBenefitsByColor(section));
      observer.observe(node, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }

  function initBenefitSelections(section) {
    if (section.dataset.benefitSelectionBound === 'true') return;
    section.dataset.benefitSelectionBound = 'true';

    const wrappers = getVisibleBenefitWrappers(section);

    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const defaultSelected = wrapper.dataset.benefitSelectedDefault === 'true' || wrapper.classList.contains('is-selected');
      setBenefitSelected(wrapper, defaultSelected);
    });

    resolveExclusiveGroupDefaults(wrappers);
    ensurePickOneGiftSelected(section);

    section.addEventListener('click', (event) => {
      const wrapper = event.target.closest('.product-wrapper[data-benefit-variant-id]');
      if (!wrapper || !section.contains(wrapper)) return;

      if (wrapper.closest('.benefit-wrapper.is-variant-hidden')) return;

      if (event.target.closest('[data-warranty-care-open]') || event.target.closest('.benefit-tip-button')) {
        return;
      }

      if (wrapper.dataset.benefitAvailable !== 'true') return;
      if (isBenefitLocked(wrapper)) return;

      const visibleWrappers = getVisibleBenefitWrappers(section);
      const shouldSelect = !wrapper.classList.contains('is-selected');

      if (!shouldSelect && isPickOneGiftWrapper(wrapper)) {
        return;
      }

      applyBenefitSelectionRules(visibleWrappers, wrapper, shouldSelect);
      setBenefitSelected(wrapper, shouldSelect);

      if (shouldSelect) {
        const benefitWrapper = wrapper.closest('.benefit-wrapper');
        if (benefitWrapper) pushBenefitSelectContentGa4(benefitWrapper);
      }
    });
  }

  function getMainProductContext(form, section, mainVariantId) {
    const formData = new FormData(form);
    let title = String(formData.get('title') || '').trim();
    let option1 = String(formData.get('option1') || '').trim();
    let option2 = String(formData.get('option2') || '').trim();

    const activeColorOption = section.querySelector(
      '.radio-wrapper[data-option-name="Color"] .options-color-wrapper.active, .radio-wrapper[data-option-name="Colour"] .options-color-wrapper.active'
    );
    if (activeColorOption) {
      option1 = String(activeColorOption.dataset.option1 || '').trim() || option1;
      option2 = String(activeColorOption.dataset.option2 || '').trim() || option2;
      if (!option1) {
        const colorValueNode = activeColorOption.querySelector('[data-value]');
        option1 = String(colorValueNode?.dataset?.value || activeColorOption.dataset.title || '').trim();
      }
    }

    if (!option1) {
      const currentColor = section.querySelector('.current-option-color');
      option1 = String(currentColor?.textContent || '').trim();
    }

    if (!title) {
      const productNameNode = section.querySelector('.product-right .product-name, .class-product-tab .product-name');
      title = String(productNameNode?.textContent || '').trim();
    }

    return {
      variantId: String(mainVariantId || ''),
      title,
      option1,
      option2,
    };
  }

  function collectSelectedGifts(section, quantity, mainProductContext) {
    const selectedWrappers = section.querySelectorAll(
      '.purchase-block .benefit-wrapper:not(.is-variant-hidden) .product-wrapper.is-selected[data-benefit-variant-id][data-benefit-available="true"]'
    );

    const selectedItems = [];
    selectedWrappers.forEach((wrapper) => {
      const variantId = Number(wrapper.dataset.benefitVariantId);
      if (!Number.isFinite(variantId) || variantId <= 0) return;
      const benefitHandle = wrapper.closest('.benefit-wrapper')?.dataset?.benefit || '';
      const item = {
        id: variantId,
        quantity,
      };

      if (mainProductContext?.variantId) {
        const mainVariantId = String(mainProductContext.variantId);
        item.properties = {
          _warranty_main_variant_id: mainVariantId,
          _benefit_linked: 'true',
          _benefit_handle: benefitHandle,
          _bundle_item_type: getBundleItemType(benefitHandle),
          _bundle_locked: 'true',
        };
      }

      if (benefitHandle === 'shokz-care-extra-1-year-gift' && mainProductContext?.variantId) {
        const warrantyFieldsResolver = window.getWarrantyFieldValuesByMainVariantId;
        const mappedFields = typeof warrantyFieldsResolver === 'function'
          ? warrantyFieldsResolver(mainProductContext.variantId)
          : null;
        const fallbackRemark = [mainProductContext.option1, mainProductContext.option2]
          .filter((value) => value != null && String(value).trim() !== '')
          .join(' / ');
        item.properties.Remark = mappedFields && mappedFields.remark ? mappedFields.remark : fallbackRemark;
        if (mappedFields && mappedFields.extendedWarrantyProductSku) {
          item.properties.extended_warranty_product_sku = mappedFields.extendedWarrantyProductSku;
        }
      }

      selectedItems.push(item);
    });

    const apExclusiveHandle = getApExclusiveGiftHandle();
    if (apExclusiveHandle) {
      const hasSelectedApExclusiveGift = selectedItems.some((item) => {
        const handle = String(item?.properties?._benefit_handle || '').toLowerCase();
        return handle === apExclusiveHandle;
      });

      if (!hasSelectedApExclusiveGift) {
        const apGiftWrapper = section.querySelector(
          `.purchase-block .benefit-wrapper[data-benefit="${apExclusiveHandle}"] .product-wrapper[data-benefit-variant-id][data-benefit-available="true"]`
        );

        if (apGiftWrapper && mainProductContext?.variantId) {
          const apVariantId = Number(apGiftWrapper.dataset.benefitVariantId);
          if (Number.isFinite(apVariantId) && apVariantId > 0) {
            const apItem = {
              id: apVariantId,
              quantity,
              properties: {
                _warranty_main_variant_id: String(mainProductContext.variantId),
                _benefit_linked: 'true',
                _benefit_handle: apExclusiveHandle,
                _bundle_item_type: 'ap_exclusive_gift',
                _bundle_locked: 'true',
              },
            };
            selectedItems.push(apItem);
          }
        }
      }
    }

    return selectedItems;
  }

  function getGiftCartApi() {
    return window.opendotsGiftCart || null;
  }

  async function submitWithBundle(form, section, event) {
    if (form.dataset.bundleSubmitting === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return true;
    }

    if (!hasPickOneGiftSelected(section)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return true;
    }

    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    if (!Number.isFinite(variantId) || variantId <= 0) return false;

    const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
    const mainProductContext = getMainProductContext(form, section, variantId);
    const gifts = collectSelectedGifts(section, quantity, mainProductContext);
    const giftCartApi = getGiftCartApi();

    if (!gifts.length || !giftCartApi || typeof giftCartApi.addBundle !== 'function') return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.bundleSubmitting = 'true';

    const submitButton = form.querySelector('.btn--add-to-cart');
    if (submitButton) {
      submitButton.classList.remove('is-added');
      submitButton.classList.add('is-adding');
      submitButton.setAttribute('disabled', 'disabled');
    }

    const mainItem = { id: variantId, quantity };

    try {
      const result = await giftCartApi.addBundle(
        {
          mainItem,
          giftItems: gifts,
          form,
        },
        {
          skipLegacyGiftSync: true,
        }
      );

      if (typeof window.productAddGa4 === 'function') {
        const gaItems = Array.isArray(result.mainData) ? result.mainData : [result.mainData];
        const mainGaItem = gaItems.find((item) => String(item?.id || item?.variant_id || '') === String(variantId));
        window.productAddGa4(mainGaItem || result.mainData);
      }
    } catch (errorData) {
      const nativeMainResult = await giftCartApi.postMainItemFromForm(form);
      if (nativeMainResult.ok) {
        giftCartApi.syncCartUi({ skipLegacyGiftSync: true });
        if (typeof window.productAddGa4 === 'function') {
          window.productAddGa4(nativeMainResult.data);
        }
        return true;
      }

      console.error('Benefit bundle add to cart failed:', errorData, nativeMainResult);
    } finally {
      delete form.dataset.bundleSubmitting;
      if (submitButton) {
        submitButton.classList.remove('is-adding');
        submitButton.removeAttribute('disabled');
      }
    }

    return true;
  }

  function bindBundleSubmit(section) {
    const forms = section.querySelectorAll('form[data-product-form]');
    if (!forms.length) return;

    forms.forEach((form) => {
      if (form.dataset.benefitBundleBound === 'true') return;
      form.dataset.benefitBundleBound = 'true';

      form.addEventListener('submit', (event) => {
        submitWithBundle(form, section, event);
      }, true);
    });
  }

  function initSection(selector) {
    const section = document.querySelector(selector);
    if (!section) return;
    bindBenefitColorSync(section);
    updateBenefitsByColor(section);
    initBenefitSelections(section);
    bindBundleSubmit(section);
  }

  function initAllSections() {
    SECTION_SELECTORS.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAllSections);
  document.addEventListener('shopify:section:load', initAllSections);
})();
